<script lang="ts" setup>
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import {
    DialogClose,
    DialogContent,
    type DialogContentEmits,
    type DialogContentProps,
    DialogOverlay,
    DialogPortal,
    useForwardPropsEmits
  } from 'reka-ui'
  import { cn } from '@/lib/utils'
  import { Button } from '~/components/ui/button'
  import { CloseIcon } from '~/components/icons'
  import { sheetVariants, type SheetVariants } from '.'

  const props = defineProps<DialogContentProps & { class?: HTMLAttributes['class']; side?: SheetVariants['side'] }>()
  const emits = defineEmits<DialogContentEmits>()

  const delegatedProps = reactiveOmit(props, 'class', 'side')

  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DialogPortal>
    <DialogOverlay
      class="fixed inset-0 z-50 bg-primary/30 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
    />
    <DialogContent :class="cn(sheetVariants({ side: props.side }), props.class)" v-bind="forwarded">
      <slot />

      <DialogClose class="absolute right-4 top-4 rounded-sm focus:outline-none focus:ring-2 focus:ring-ring">
        <Button class="size-8" variant="outline">
          <CloseIcon />
          <span class="sr-only">{{ $t('common.close') }}</span>
        </Button>
      </DialogClose>
    </DialogContent>
  </DialogPortal>
</template>
